import React, { Component } from 'react'
import styles from './Gallery.css'


/*const numberSort = (a, b) => a - b*/

const mod = (offset, offsets) => {
  for (var i = 0; i < offsets.length; i++) {
    if (offset < offsets[i]) {
      return Math.max(0, i - 1)
    }
  }
  return offsets.length - 1
}


export default class Gallery extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isDragging: false,
      offset: 0,
      initialModalIndex: 0,
    }

    this.currentScreen = 0
  }

  componentWillMount () {
    this.velocity = 0
    this.ticking = false
    this.lastClientX = null
    this.loadedCount = 0
    this.offsets = []
    this.currentScreen = 0
    this.imgs = []
  }

  componentDidMount () {
    window.addEventListener('resize', this.calculateOffsets)
    window.addEventListener('deviceorientation', this.handleOrientation)
    //this.intervalForce = setInterval(this.tryUpdateForce, 60)
    this.orientationGamma = 0
    this.orientationAlpha = 0
  }

  componentWillUnmount () {
    this.ticking = 0
    window.removeEventListener('resize', this.calculateOffsets)
    window.removeEventListener('deviceorientation', this.handleOrientation)
    //window.clearInterval(this.intervalForce)
    //this.tickingForce = false
  }


  tryUpdateForce = () => {
    if (!this.tickingForce) {
      this.tickingForce = true
      this.updateForce()
    }
  }

  updateForce = () => {
    if (this.tickingForce && !this.state.isDragging) {
      const distToCurrent = -this.state.offset - (this.currentScreen * document.body.offsetWidth)
      this.velocity += -distToCurrent / 10
      this.velocity *= Math.abs(1 / (1 + Math.exp(-distToCurrent*5)) - 0.5)
      this.requestUpdate()
    }
    this.tickingForce = false
  }


  calculateOffsets = () => {
    this.offsets = this.imgs.map((img, i) => (
      i * document.body.offsetWidth
    ))
  }

  handleOrientation = (e) => {
    if (!this.tickingOrientation) {
      this.tickingOrientation = true
      window.requestAnimationFrame(this.updateOrientation(e))
    }
  }

  updateOrientation = (e) => () => {
    const directionGamma = Math.round(360 - e.gamma)
    const directionAlpha = Math.round(360 - e.alpha)

    var deltaGamma = directionGamma - this.orientationGamma
    if (deltaGamma < -180) {
      deltaGamma += 360
    }
    if (deltaGamma > 180) {
      deltaGamma -= 360
    }

    var deltaAlpha = directionAlpha - this.orientationAlpha
    if (deltaAlpha < -180) {
      deltaAlpha += 360
    }
    if (deltaAlpha > 180) {
      deltaAlpha -= 360
    }

    const total = (deltaGamma + deltaAlpha)
    this.velocity += (total*total) * (total > 0 ? 1 : -1) / 5 + total
    this.requestUpdate()
    this.orientationGamma = directionGamma
    this.orientationAlpha = directionAlpha

    this.tickingOrientation = false
  }

  update = () => {
    if (this.ticking) {
      const lastWidth = document.body.offsetWidth
      const offset = Math.max(-this.imagesComp.offsetWidth + lastWidth,
                       Math.min(0,
                         this.state.offset - this.velocity))
      this.setState({
        offset: offset,
      })

      this.currentScreen = mod(-offset + document.body.offsetWidth * 0.5, this.offsets)
      this.velocity *= 0.95
      this.ticking = false
      if (Math.abs(this.velocity) >= 0.01) {
        this.requestUpdate()
      }
    }
  }

  requestUpdate = () => {
    if (!this.ticking) {
      this.ticking = true
      requestAnimationFrame(this.update)
    }
  }


  handleMouseDown = (event) => {
    this.setState({ isDragging: true })
    this.lastClientX = event.touches ? event.touches[0].clientX : event.clientX
    this.mouseStart = this.lastClientX
    this.canOpenModal = true
  }

  handleMouseMove = (event) => {
    if (this.state.isDragging) {
      if (Math.abs(this.velocity) > 0.5) {
        this.canOpenModal = false
      }

      const clientX = event.touches ? event.touches[0].clientX : event.clientX
      this.velocity = 0.5 * this.velocity + (this.lastClientX - clientX)
      this.lastClientX = clientX
      this.requestUpdate()
    }
  }

  handleMouseUp = () => this.setState({ isDragging: false })
  handleMouseLeave = () => this.setState({ isDragging: false })


  animateToIndex = (index) => {
    // v(t) = Ce^((f-1)t)
    // C = d * (1 - f)
    //   = d * (1 - 0.9)
    //   = d * 0.1
    //
    // but 0.1001 from experiment
    //
    // note: offset < 0
    console.log(this.offsets[index], this.state.offset)
    this.velocity = 0.1001 * (this.offsets[index] - (-this.state.offset)) / 2
    this.requestUpdate()
  }

  handleLeftArrowClick = () => {
    this.animateToIndex((this.currentScreen - 1 + this.props.items.length) % this.props.items.length)
  }

  handleRightArrowClick = () => {
    this.animateToIndex((this.currentScreen + 1 + this.props.items.length) % this.props.items.length)
  }

  bindImagesComp = comp => this.imagesComp = comp

  handleImageClick = id => this.canOpenModal && this.props.handleImageClick(id)

  handleLoad = (element, key) => {
    this.loadedCount = this.loadedCount + 1
    this.imgs[key] = (element)
    if (this.loadedCount == this.props.items.length) {
      this.calculateOffsets()
    }
  }


  render () {
    if (!this.props.items || !this.props.items.length) {
      return null
    }
    return (
      <div className={styles.cont}>
        <div className={styles.imagesCont}
          onMouseDown={this.handleMouseDown}
          onMouseMove={this.handleMouseMove}
          onMouseUp={this.handleMouseUp}
          onMouseLeave={this.handleMouseLeave}
          onTouchStart={this.handleMouseDown}
          onTouchMove={this.handleMouseMove}
          onTouchEnd={this.handleMouseUp}
          onTouchCancel={this.handleMouseUp}
        >
          <div ref={this.bindImagesComp} className={styles.images} style={{
            transform: "translateX("+this.state.offset+"px)",
          }}>
            {
              this.props.items.map((item, itemKey) => (
                <Item item={item} key={itemKey} itemKey={itemKey} handleLoad={this.handleLoad} handleClick={this.handleImageClick} first={itemKey == 0}/>
              ))
            }
          </div>
        </div>
        <div className={styles.leftArrow} onClick={this.handleLeftArrowClick}/>
        <div className={styles.rightArrow} onClick={this.handleRightArrowClick}/>
      </div>
    )
  }
}

class Item extends Component {
  componentDidMount () {
    this.props.handleLoad(this.c, this.props.itemKey)
  }
  handleClick = () => {
    this.props.handleClick(this.props.itemKey)
  }
  bindCont = (c) => {this.c = c}
  render () {
    return (
      <div ref={this.bindCont} className={styles.image +' '+ (this.props.first ? styles.first : '')} style={{
        width: document.body.offsetWidth,
      }}>
        <div className={styles.img} style={{
          backgroundImage: 'url('+this.props.item.image+')',
          backgroundPosition: this.props.item.imagePosition || '',
        }}>

          <div className={styles.heroTitle}>
            {this.props.item.room && (
              <div className={styles.heroRoomNumber}>
                {this.props.item.room}
              </div>
            )}
            {this.props.item.primaryTitle}
          </div>
          <div className={styles.heroYear}>
            — {this.props.item.year}
          </div>

          <div className={styles.enterButton} onClick={this.handleClick}>
            ENTER
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Rist/modules/Tour/Gallery/index.js